import { Component, OnInit, Input } from '@angular/core';
import { ApiService, AuthService, TohumUiModule, User } from '@anadolu-commons/tohum-ui';
import { ActivatedRoute} from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { SharedService } from '../shared/shared.service';

@Component({
  templateUrl: './odeme-basarili.component.html',
  selector: 'odeme-basarili',
  standalone: true,
  imports: [TohumUiModule],
  styles: []
})
export class OdemeBasariliComponent implements OnInit {

  @Input() model: any;

  user: User;
  profilId: string;
  yerineGirisMi: boolean = false;

  adayBasvuruId: number;
  odemeBasarili: boolean = false;
  
  constructor(private readonly apiService:ApiService,private readonly activatedRoute: ActivatedRoute, 
    private authService: AuthService, private sharedService: SharedService, private funcs: FuncsService) { 
      
    this.sharedService.profil$.subscribe((aday) => {
      this.profilId = aday.profilId;
      this.yerineGirisMi = aday.yerineGirisMi;
    });
    this.activatedRoute.params.subscribe(params => {
      this.adayBasvuruId = params.id;
    }); 
  }
  
  ngOnInit() {
    this.user = this.authService.getUser();

    this.apiService.get('borc-sorgula/borc-kontrol-et-aday-basvuru-durum-guncelle/',  
    { 
      adayBasvuruId: this.adayBasvuruId, 
      profilId: this.profilId, 
      girisYapanKullaniciId: this.user.id,
      yerineGirisMi: this.yerineGirisMi,
    })
    .subscribe(
      result => { 
        this.odemeBasarili = true;     
      }, error => {
        this.funcs.hataMesajiVer(error);
      });
  }
}
